if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // === DEBUG QUANTITE ===
      const productInfo = this.closest('product-info');
      const allQtyInputs = document.querySelectorAll('.quantity__input');
      const qtyByForm = document.querySelector('.quantity__input[form="' + this.form.id + '"]');
      const qtyByProductInfo = productInfo && productInfo.querySelector('.quantity__input');

      console.group('DEBUG Quantite ProductForm');
      console.log('form.id:', this.form.id);
      console.log('product-info trouve:', !!productInfo);
      console.log('Nb .quantity__input trouves:', allQtyInputs.length);
      allQtyInputs.forEach(function(el, i) {
        console.log('  input[' + i + '] value=' + el.value + ' form=' + el.getAttribute('form') + ' id=' + el.id);
      });
      console.log('qtyByForm:', qtyByForm ? 'value=' + qtyByForm.value : 'NULL');
      console.log('qtyByProductInfo:', qtyByProductInfo ? 'value=' + qtyByProductInfo.value : 'NULL');
      console.log('FormData(form).get(quantity):', new FormData(this.form).get('quantity'));
      console.groupEnd();
      // === FIN DEBUG ===

      const quantityInputEl = qtyByProductInfo || qtyByForm;
      const capturedQuantity = quantityInputEl ? (parseInt(quantityInputEl.value) || 1) : 1;
      console.log('capturedQuantity envoye au panier:', capturedQuantity);

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.set('quantity', capturedQuantity);
      console.log('formData quantity final:', formData.get('quantity'));

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id')
          });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(false);
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}